/* ============================================================
   SVADEZI LUXE — storefront interactions
   Vanilla JS port of the prototype's React behaviour.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Sticky header shadow on scroll ---- */
  function initSticky() {
    var bar = document.querySelector('.hdr-main');
    if (!bar) return;
    var on = function () {
      if (window.scrollY > 40) bar.classList.add('stuck');
      else bar.classList.remove('stuck');
    };
    on();
    window.addEventListener('scroll', on, { passive: true });
  }

  /* ---- Metal toggle (Gold / Silver) ----
     Persists choice and reflects it on <body data-metal>. Section copy that
     depends on metal is rendered with both variants; CSS/markup can react. */
  function initMetalToggle() {
    var toggles = document.querySelectorAll('.metal-toggle');
    var apply = function (metal) {
      document.body.setAttribute('data-metal', metal);
      try { localStorage.setItem('svz-metal', metal); } catch (e) {}
      document.querySelectorAll('.metal-toggle').forEach(function (t) {
        var thumb = t.querySelector('.metal-thumb');
        if (thumb) thumb.setAttribute('data-metal', metal);
        t.querySelectorAll('button[data-metal]').forEach(function (b) {
          var on = b.getAttribute('data-metal') === metal;
          b.classList.toggle('on', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      });
      document.querySelectorAll('[data-metal-word]').forEach(function (el) {
        el.textContent = metal === 'silver' ? 'Silver' : 'Gold';
      });
    };
    var saved = 'gold';
    try { saved = localStorage.getItem('svz-metal') || 'gold'; } catch (e) {}
    toggles.forEach(function (t) {
      t.querySelectorAll('button[data-metal]').forEach(function (b) {
        b.addEventListener('click', function () { apply(b.getAttribute('data-metal')); });
      });
    });
    if (toggles.length) apply(saved);
  }

  /* ---- Latest Arrivals tabs ---- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('.arr-tab');
      var panels = root.querySelectorAll('.arr-panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('on', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('on', p.getAttribute('data-panel') === key);
          });
        });
      });
    });
  }

  /* ---- Wishlist toggle (local only; swap for an app/metafield later) ---- */
  function initWishlist() {
    var key = 'svz-wishlist';
    var saved = [];
    try { saved = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
    document.querySelectorAll('.wish').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (id && saved.indexOf(id) !== -1) btn.classList.add('on');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        btn.classList.toggle('on');
        if (!id) return;
        var i = saved.indexOf(id);
        if (i === -1) saved.push(id); else saved.splice(i, 1);
        try { localStorage.setItem(key, JSON.stringify(saved)); } catch (e2) {}
      });
    });
  }

  /* ---- Reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- AJAX add to cart ---- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.setAttribute('data-n', count);
      el.textContent = count;
    });
  }
  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCartCount(c.item_count); })
      .catch(function () {});
  }
  function initAddToCart() {
    document.querySelectorAll('form[data-cart-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.prod-add');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (btn) { btn.textContent = 'Added ✓'; }
            refreshCartCount();
            setTimeout(function () {
              if (btn) { btn.disabled = false; btn.textContent = original; }
            }, 1400);
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = original; }
          });
      });
    });
  }

  /* ---- Material toggle (tone + karat live spec) ---- */
  function initMaterialToggle() {
    var TONE = {
      yellow: { label: 'Yellow', sub: 'Warm 22-carat hue' },
      rose:   { label: 'Rose',   sub: 'Soft copper blush' },
      white:  { label: 'Rhodium',sub: 'Cool mirror finish' }
    };
    var KARAT = { '18K': '75.0% pure', '14K': '58.5% pure', '9K': '37.5% pure' };
    document.querySelectorAll('[data-material-toggle]').forEach(function (root) {
      var prods  = root.querySelectorAll('.mat-prod');
      var toneLb = root.querySelector('[data-tone-label]');
      var toneSb = root.querySelector('[data-tone-sub]');
      var karLb  = root.querySelector('[data-karat-label]');
      var karSb  = root.querySelector('[data-karat-sub]');
      var thumb  = root.querySelector('[data-karat-thumb]');
      root.querySelectorAll('.tone-chip[data-tone]').forEach(function (b) {
        b.addEventListener('click', function () {
          var t = b.getAttribute('data-tone');
          root.querySelectorAll('.tone-chip').forEach(function (x) { x.classList.toggle('on', x === b); });
          prods.forEach(function(prod) {
            prod.setAttribute('data-tone', t);
            var newSrc = prod.getAttribute('data-src-' + t);
            if (newSrc) prod.src = newSrc;
          });
          if (toneLb) toneLb.textContent = TONE[t].label;
          if (toneSb) toneSb.textContent = TONE[t].sub;
        });
      });
      root.querySelectorAll('[data-karat-toggle] button[data-karat]').forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-karat');
          root.querySelectorAll('[data-karat-toggle] button').forEach(function (x) { x.classList.toggle('on', x === b); });
          if (thumb) {
            thumb.style.transform = k === '14K' ? 'translateX(100%)' : k === '9K' ? 'translateX(200%)' : 'none';
          }
          if (karLb) karLb.textContent = k;
          if (karSb) karSb.textContent = KARAT[k];
        });
      });
    });
  }

  /* ---- Compare drag slider ---- */
  function initCompare() {
    document.querySelectorAll('[data-cmp-viewer]').forEach(function (viewer) {
      var right   = viewer.querySelector('[data-cmp-right]');
      var divider = viewer.querySelector('[data-cmp-divider]');
      var handle  = viewer.querySelector('[data-cmp-handle]');
      var dragging = false;
      function setPos(clientX) {
        var r = viewer.getBoundingClientRect();
        var p = ((clientX - r.left) / r.width) * 100;
        if (p < 8) p = 8; if (p > 92) p = 92;
        if (right)   right.style.clipPath = 'inset(0 0 0 ' + p + '%)';
        if (divider) divider.style.left = p + '%';
        if (handle)  handle.style.left = p + '%';
      }
      viewer.addEventListener('mousedown', function (e) { dragging = true; setPos(e.clientX); });
      viewer.addEventListener('touchstart', function (e) { dragging = true; setPos(e.touches[0].clientX); }, { passive: true });
      window.addEventListener('mousemove', function (e) { if (dragging) setPos(e.clientX); });
      window.addEventListener('touchmove', function (e) { if (dragging && e.touches[0]) setPos(e.touches[0].clientX); }, { passive: true });
      window.addEventListener('mouseup', function () { dragging = false; });
      window.addEventListener('touchend', function () { dragging = false; });
    });
  }

  /* ---- Certificate flip on click ---- */
  function initCertFlip() {
    document.querySelectorAll('[data-cert-flip]').forEach(function (el) {
      el.addEventListener('click', function () { el.classList.toggle('flip'); });
    });
  }

  /* ---- Live gold-rate ticker ---- */
  function initPriceTicker() {
    var el = document.querySelector('[data-price-ticker]');
    if (!el) return;
    var CACHE_KEY = 'svz-rates';
    var TTL = 24 * 60 * 60 * 1000;
    var displays = {
      '22k': el.querySelector('[data-rate-display="22k"]'),
      '18k': el.querySelector('[data-rate-display="18k"]'),
      '14k': el.querySelector('[data-rate-display="14k"]'),
      silver: el.querySelector('[data-rate-display="silver"]')
    };
    var asof = el.querySelector('[data-rate-asof]');
    function paint(rates, when) {
      if (rates['22k'] && displays['22k']) displays['22k'].textContent = '₹' + Math.round(rates['22k']) + '/g';
      if (rates['18k'] && displays['18k']) displays['18k'].textContent = '₹' + Math.round(rates['18k']) + '/g';
      if (rates['14k'] && displays['14k']) displays['14k'].textContent = '₹' + Math.round(rates['14k']) + '/g';
      if (rates.silver && displays.silver) displays.silver.textContent = '₹' + Math.round(rates.silver * 0.925) + '/g';
      if (asof && when) asof.textContent = when;
    }
    // Load from Product cache first
    try {
      var cached = JSON.parse(sessionStorage.getItem('SvadeziLiveMetalRates'));
      if (cached) {
        paint({
          '22k': cached.gold_22k,
          '18k': cached.gold_18k,
          '14k': cached.gold_14k,
          silver: cached.silver_999
        }, 'Today');
        return;
      }
    } catch (e) {}

    // Fetch via secure proxy
    if (typeof window.fetchSvadeziLiveRates !== 'function') return;

    window.fetchSvadeziLiveRates().then(function(responses) {
      return Promise.allSettled([
        responses[0].json(),
        responses[1].json()
      ]);
    }).then(function(results) {
      var goldData = results[0] && results[0].status === 'fulfilled' ? results[0].value : null;
      var silverData = results[1] && results[1].status === 'fulfilled' ? results[1].value : null;
      
      if (!goldData || !goldData.price_gram_24k) return;
      
      var rates = {
        '22k': goldData.price_gram_22k,
        '18k': goldData.price_gram_18k,
        '14k': goldData.price_gram_14k,
        silver: silverData ? (silverData.price_gram_24k || (silverData.price / 31.1034768)) : 0
      };
      
      var when = new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
      paint(rates, when);
      
      var toCache = {
        gold_24k: goldData.price_gram_24k,
        gold_22k: goldData.price_gram_22k,
        gold_21k: goldData.price_gram_21k,
        gold_20k: goldData.price_gram_20k,
        gold_18k: goldData.price_gram_18k,
        gold_14k: goldData.price_gram_14k,
        gold_10k: goldData.price_gram_10k,
        silver_999: rates.silver
      };
      try { sessionStorage.setItem('SvadeziLiveMetalRates', JSON.stringify(toCache)); } catch(e) {}
    }).catch(function() { /* admin values remain */ });
  }

  function init() {
    initSticky();
    initMetalToggle();
    initTabs();
    initWishlist();
    initReveal();
    initAddToCart();
    initMaterialToggle();
    initCompare();
    initCertFlip();
    initPriceTicker();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* Re-init when sections are re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', init);
})();
